module.exports = __webpack_public_path__ + "static/media/madfit-9.0edeccc1.jpg";